module.exports = __webpack_public_path__ + "img/about-curator-2.a15bf260.png";